module.exports = __webpack_public_path__ + "static/media/client3.6bd5acae.webp";